export default class TPSTeamView {
	id = null
	
	name = null
	logoUrl = null
	email = null
	institution = null

	constructor()
	{
	}
}